import { Action } from 'redux';
import { CarModelListFilters, CarModelModel } from '../../../api/core/core.types';
import { Page } from '../../../api/api.types';

export const GET_CAR_MODELS_LIST = 'GET_CAR_MODELS_LIST';
export const GET_CAR_MODEL = 'GET_CAR_MODEL';
export const POST_CAR_MODEL = 'POST_CAR_MODEL';
export const PUT_CAR_MODEL = 'PUT_CAR_MODEL';
export const DELETE_CAR_MODEL = 'DELETE_CAR_MODEL';
export const UPDATE_CAR_MODEL_FILTERS = 'UPDATE_CAR_MODEL_FILTERS';

export interface GetCarModelsListAction extends Action {
  type: typeof GET_CAR_MODELS_LIST;
  payload: {
    page: Page<CarModelModel>;
  };
}

export interface GetCarModelAction extends Action {
  type: typeof GET_CAR_MODEL;
  payload: {
    selectedCarModel: CarModelModel | null;
  };
}

export interface PostCarModelAction extends Action {
  type: typeof POST_CAR_MODEL;
  payload: {
    success: boolean;
    newCarModel: CarModelModel | null;
  };
}

export interface PutCarModelAction extends Action {
  type: typeof PUT_CAR_MODEL;
  payload: {
    selectedCarModel: CarModelModel;
  };
}

export interface DeleteCarModelAction extends Action {
  type: typeof DELETE_CAR_MODEL;
  payload: {
    success: boolean;
  };
}

export interface UpdateCarModelFiltersAction extends Action {
  type: typeof UPDATE_CAR_MODEL_FILTERS;
  payload: {
    filters: CarModelListFilters;
  };
}

export interface CarModelsState {
  carModels: CarModelModel[] | [];
  selectedCarModel: CarModelModel | null;
  postSuccess: boolean | null;
  lastFetch: number | null;
  totalElements: number;
  totalPages: number;
  filters: CarModelListFilters | null;
}

export type CarModelActionTypes = GetCarModelsListAction | GetCarModelAction | PostCarModelAction | DeleteCarModelAction | PutCarModelAction | UpdateCarModelFiltersAction;
